import * as React from 'react';
export const naverPaySvg = React.forwardRef(function naverPaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#00DE5A',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M18.004 10.36v6.036l-4.188-6.036H10.36v11.28h3.636v-6.036l4.188 6.036h3.456V10.36h-3.636ZM28 16c0 6.624-5.376 12-12 12S4 22.624 4 16 9.376 4 16 4s12 5.376 12 12Z',
      fill: '#fff',
    }),
  );
});
naverPaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var naverPay = {
  category: 'brand',
  colorable: false,
  name: 'naverPay',
  svg: naverPaySvg,
};
